<template>
  <aside role="complementary" class="eb-aside" :class="[hasClass]" @keydown.esc="toggleMainNav()">
    <div class="eb-logo-dep" v-if="!isMobile && !isSmallScreen">
      <img loading="lazy" src="https://cdn.maine-et-loire.fr/ecosysteme_ressources/img/a.svg" width="533" height="151" alt="" />
    </div>

    <img src="@/assets/img/logo.svg" class="eb-container-brand-logo" alt="Assistants maternels - Partenaires" />

    <nav class="eb-nav" role="navigation" aria-label="Navigation principale">
			<button v-if="!isOpened && $route.path == '/accueil' && (isMobile || isSmallScreen)" class="burger-button menu-icon" :class="{hidden: isOpened && (isMobile || isSmallScreen)}" type="button" aria-label="Ouvrir la navigation principale" aria-controls="main-nav" @click="toggleMainNav()">
        <span aria-hidden="true"></span>
      </button>
      <span v-if="isOpened" class="eb-menu-title">Menu</span>

      <ul id="main-nav" v-if="isOpened || !isSmallScreen">
        <li>
          <router-link :to="{ name: 'home' }" @click.native="toggleMainNav">Liste des assistants maternels</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'contact' }" @click.native="toggleMainNav">Contact</router-link>
        </li>
      </ul>

      <button v-if="isOpened" class="menu-close-icon" aria-label="Fermer la navigation principale" aria-controls="main-nav" :aria-selected="!isOpened ? 'true' : 'false'" @click="toggleMainNav()" type="button">
        <strong aria-hidden="true">&times;</strong>
      </button>
    </nav>

    <footer v-if="(isOpened && (isMobile || isSmallScreen)) || (!isMobile && !isSmallScreen)" class="eb-footer">
      <ul>
        <li>
          <router-link :to="{ name: 'accessibilite' }">Accessibilité : partiellement conforme</router-link>
        </li>
        <li>
          <a href="https://assmat.maine-et-loire.fr/mentions-legales" target="_blank" rel="noreferrer noopener" title="Mentions légales - assmat.maine-et-loire.fr (Nouvelle fenêtre)"
            >Mentions légales <font-awesome-icon :icon="['fas', 'external-link-alt']"
          /></a>
        </li>
        <li>
					<a
						href="https://assmat.maine-et-loire.fr/donnees-personnelles"
						target="_blank"
						rel="noreferrer noopener"
						title="Confidentialité et protection des données - assmat.maine-et-loire.fr (Nouvelle fenêtre)"
            >Confidentialité et protection des données <font-awesome-icon :icon="['fas', 'external-link-alt']"
          /></a>
        </li>
      </ul>
    </footer>
  </aside>
</template>

<script>
import {mapActions} from "vuex"
export default {
	name: "sideMenu",
  data() {
    return {
      isOpened: false,
			isInitiallyVisible: false,
		}
  },
  created() {
		window.addEventListener("resize", this.onResize)
  },
  destroyed() {
		window.removeEventListener("resize", this.onResize)
  },
  mounted() {
		this.onResize()
  },
  computed: {
    hasClass: function () {
			let className = ""
      if (this.isInitiallyVisible == false) {
				return ""
      } else if (this.isOpened && (this.isMobile || this.isSmallScreen)) {
				return "slide-in"
      } else if (!this.isOpened && (this.isMobile || this.isSmallScreen)) {
				return "slide-out"
    }
			return className
		},
  },
  methods: {
		...mapActions(["updateScreenSize"]),
    toggleMainNav: function () {
      if (this.isOpened) {
				this.isOpened = false
      } else {
				this.isOpened = true
				this.isInitiallyVisible = true
      }
    },
    onResize: async function () {
			await this.updateScreenSize()
      if (window.innerWidth < 768) {
				this.isInitiallyVisible = false
				this.isOpened = false
      } else {
				this.isInitiallyVisible = true
				this.isOpened = true
    }
		},
	},
  }
</script>
